import React, { useEffect, useState } from 'react';
import FactorJoz from './FactorJoz/FactorJoz';
import Factorkol from './FactorKol/FactorKol';
import CardResponsive from './FactorKol/CardResponsive';
import './FormFactor.scss';
import objectDataHolder from "../Hooks/ObjectDataHolder";
import _axios from "../../httpService";
import Loader from "../Loader";
import { prefixUrl } from '../../utils/utilsData';
import Swal from "sweetalert2";
import {useLocation, useNavigate} from "react-router-dom";

const FormAtelier = () => {

  const myLocation = useLocation();
  const navigateTo = useNavigate()

  const [totalInvoice, setTotalInvoice] = useState(0);

  const [totalColumnSum, setTotalColumnSum] = useState(0);

  const [initialData, setInitialData] = useState(objectDataHolder({
    RLookUpId: null, // Initialize with null
    typeOfServices: [] // Initialize with an empty array
  }));

  const [loader, setLoader] = useState(true)

  const [mode , setMode] = useState('add');

  const [recordData, setRecordData] = useState([]);

  const [backendData, setBackendData] = useState({});

  const handleTotalInvoiceChange = (newTotalInvoice) => {
    setTotalInvoice(newTotalInvoice);
  };

  const handleTotalColumnSumChange = (sum) => {
    setTotalColumnSum(sum);
  };

  useEffect(() => {
    if (prefixUrl() === null) {
      // alert(prefixUrl)
      window.location.reload()
    }

    if (myLocation.state) {
      const id = myLocation.state.id
      console.log(id);
      debugger
      _axios.get(prefixUrl() + "/shutterFactor/?request=factorSubmitedData&id=" + id).then(res => {

        const data = res.data;
        if (data.status) {

          setBackendData(data.data);
          setMode('edit'); 
          setLoader(false);
          
        } else {
          Swal.fire({
            title: data.message,
            text: "لطفا بعد از اعمال تغییرات مجددا تلاش کنید.",
            icon: 'error',
            showCancelButton: false,
            allowOutsideClick: true,
            showConfirmButton: true,
            confirmButtonText: 'برو به داشبورد'
          }).then((result) => {
            if (result.isConfirmed) {
              navigateTo("/dashboard")
            }
          })

        }
      })

    } 

  }, [])

    useEffect(() => {
    _axios.get(prefixUrl() + '/shutterFactor/?request=initialData').then(res => {
      setInitialData({
        RLookUpId: res.data.RLookUpId,
        typeOfServices: res.data.services
      });
      setLoader(false);
    });
  }, []);

  return (
    <>
      {loader ? <Loader /> :
        <>
          <div className='Factor'>
            <div className='FactorJoz'>
              <FactorJoz 
              totalInvoice={totalInvoice}
               totalColumnSum={totalColumnSum} 
               recordData={recordData} 
               initialData={initialData}
               mode={mode}
               backendData={backendData}
               />
            </div>
            <div className='FactorKol'>
              <Factorkol
               initialData={initialData} 
               totalColumnSum={totalColumnSum}
                onTotalColumnSumChange={handleTotalColumnSumChange} 
                onRecordDataChange={setRecordData}
                backendData={backendData}
               />
            </div>
            <div className='FactorCardResponsive'>
              <CardResponsive initialData={initialData} onTotalInvoiceChange={handleTotalInvoiceChange} backendData={backendData}/>
            </div>
          </div>
        </>

      }
    </>
  );
};

export default FormAtelier;
